import { duration } from '@eturi/date-util'
import {
	benefitGroup$,
	fetchGroupDetails,
	fetchSKUDefs,
	fetchSystemInfo,
	isAuthenticated$,
	isGroupSignUpAllowed$,
	setBenefitGroup,
} from '@op/services'
import { resolveSerial } from '../common'
import { isOnboarding$ } from '../compound-selectors/routes'
import { getEndpoints } from '../env'
import { landingGroupId$, landingPromoTs$, resetLandingPromos } from '../reducers/landing.slice'
import { clearLandingSSOIfExpired } from '../thunks/landing'

/**
 * Promos that come in are persisted for at most 2 weeks. They are also cleared on login or
 * sign-up. Thus, if they are unused after 2 weeks, we clear them.
 */
const EFFECTIVE_PROMO_MAX_DURATION =
	process.env.APP_ENV === 'dev' ? duration(3, 'm') : duration(2, 'w')

export const landingResolver = resolveSerial(async ({ dispatch, getState }) => {
	let state = getState()
	const isOnboarding = isOnboarding$(state)
	const isAuthenticated = isAuthenticated$(state)

	if (isOnboarding) {
		await Promise.allSettled([
			dispatch(fetchSystemInfo({ onboarding: true })),
			dispatch(fetchSKUDefs({ isUnauthenticated: !isAuthenticated })),
		])
		return
	} else {
		await dispatch(fetchSystemInfo())
	}

	// Clear SSO state if it's expired
	dispatch(clearLandingSSOIfExpired())

	// Clear promo state if it's expired
	if (landingPromoTs$(state) < Date.now() - EFFECTIVE_PROMO_MAX_DURATION) {
		dispatch(resetLandingPromos())
	}

	if (isAuthenticated$(state)) return

	// Get the new state after clearing
	state = getState()

	const [currentBenefitGroup, landingGroupId] = [benefitGroup$(state), landingGroupId$(state)]
	// If we have a group ID, and it's different from our current group, or
	// from we fetch the details

	if (landingGroupId && (!currentBenefitGroup || currentBenefitGroup.group_id !== landingGroupId)) {
		await dispatch(
			fetchGroupDetails({ groupId: landingGroupId, sfsh: getEndpoints()!.sfsh }),
		).unwrap()

		// If it cannot be applied at sign up then we clear the benefits
		if (!isGroupSignUpAllowed$(getState())) dispatch(setBenefitGroup(null))
	}
})
